import React, { useEffect, useState } from "react";
import { useKeycloakToken } from '../common/useKeycloak';
import AddConnectionDetails from "./AddConnectionDetails";
import { useNavigate } from 'react-router-dom';
import { Connection, buildDestination, Destination, DestinationType, NewIntegration, Organization, ProviderType, buildProviderType, buildNewIntegration, ConnectionConfiguration } from "../common/ObjectTypes";
import { addConnectionDestinations, createNewConnection } from "../../api/connections/connectionsApi";
import Spinner from "../common/Spinner";
import { getDestinationDetails, getDestinationsList } from "../../api/destinations/destinationsApi";
import { filterDestinationOwner } from "../destinations/DestinationHelperFunctions";
import { toast } from "react-toastify";
import { ManageDestinationModal } from "../destinations/ManageDestinationModal";
import Ajv from 'ajv';
import addFormats from 'ajv-formats';
import loadOrganizations from "../../api/organizations/loadOrganizations";
import { page_size } from "../../api/apiUtils";
import loadDestinationTypes from '../../api/destinations/loadDestinationTypes';
import loadProviderTypes from '../../api/connections/loadProviderTypesNewConnection';

export function ManageAddConnection() {
    type FilterTypes = {
        endpoint__in: FilterTags[],
        enabled: FilterTags[],
        type__in: FilterTags[],
        owner__in: FilterTags[],
        ordering: string,
        search: string
    };
    function createFilterTypes(
        endpoint__in: FilterTags[],
        enabled: FilterTags[],
        type__in: FilterTags[],
        owner__in: FilterTags[],
        ordering: string,
        search: string
    ): FilterTypes {
        return {
            endpoint__in: endpoint__in || [],
            enabled: enabled || [],
            type__in: type__in || [],
            owner__in: owner__in || [],
            ordering: ordering || "",
            search: search || ""
        }
    }
    type FilterTags = {
        name: string,
        id: string
    };
    const [token, showLoginModal, setShowLoginModal] = useKeycloakToken();
    const [destinationFilter, setDestinationFilter] = useState<FilterTypes>(createFilterTypes([], [], [], [], "", ""));
    const [initialConnection, setInitialConnection] = useState<NewIntegration>(buildNewIntegration(true))
    const [createdConnection, setCreatedConnection] = useState<Connection>()
    const [updatedConfigurations, setUpdatedConfigurations] = useState<any[]>([]);
    const [errors, setErrors] = useState({});
    const [rsjfErrors, setRsjfErrors] = useState<any[]>([]);
    const [routeId, setRouteId] = useState("");
    const [newDestinations, setNewDestinations] = useState<Destination[]>([]);
    const [providerTypes, setProviderTypes] = useState<ProviderType[]>([]);
    const [providerTypesOffset, setProviderTypesOffset] = useState<number>(0);
    const [providerTypesTotal, setProviderTypesTotal] = useState<number>(0);
    const [destinationTypes, setDestinationTypes] = useState<DestinationType[]>([]);
    const [destinationTypesOffset, setDestinationTypesOffset] = useState<number>(0);
    const [loadMoreDestinationTypes, setLoadMoreDestinationTypes] = useState(true);
    const [destinationTypesTotal, setDestinationTypesTotal] = useState<number>(0);
    const [organizations, setOrganizations] = useState<Organization[]>([]);
    const [organizationTotal, setOrganizationTotal] = useState<number>(0);
    const [loadMoreOrganizations, setLoadMoreOrganizations] = useState(true);
    const [organizationOffset, setOrganizationOffset] = useState<number>(0);
    const [totalOrgs, setTotalOrgs] = useState<number>(0);
    const [orgOffset, setOrgOffset] = useState<number>(0);
    const [orgSearchInput, setOrgSearchInput] = useState<string>("");
    const [destinations, setDestinations] = useState<Destination[]>([]);
    const [destDetailsModal, setDestDetailsModal] = useState(false);
    const [selectedDestination, setSelectedDestination] = useState<Destination>(buildDestination());
    const [reloadDestinations, setReloadDestinations] = useState<boolean>(false);
    const [selectedProviderType, setSelectedProviderType] = useState<ProviderType>(buildProviderType());
    const [totalDestinationCount, setTotalDestinationCount] = useState<number>(0);
    const [destinationOffset, setDestinationOffset] = useState<number>(0);
    const [isProviderTypeSelected, setIsProviderTypeSelected] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const navigate = useNavigate();
    const [addDestModal, setAddDestModal] = useState(false);

    const loadOrganizationsData = async (offset: number, search_str: string) => {
        if (token && typeof token === 'string') {
            const [orgs, total_orgs, error] = await loadOrganizations(token, offset, search_str, organizations);
            if (!error) {
                setOrganizations(orgs);
                setOrganizationTotal(total_orgs);
            }
        }
    }

    const loadDestinationTypesData = async (offset: number, search_str: string) => {
        if (token && typeof token === 'string') {
            const [dest_types, total_dest_types, error] = await loadDestinationTypes(token, offset, search_str, destinationTypes);
            if (!error) {
                setDestinationTypes(dest_types);
                setDestinationTypesTotal(total_dest_types);
            }
        }
    }
    const loadProviderTypesData = async (offset: number, search_str: string) => {
        if (token && typeof token === 'string') {
            const [provider_types, total_provider_types, error] = await loadProviderTypes(token, offset, search_str, providerTypes);
            if (!error) {
                setProviderTypes(provider_types);
                setProviderTypesTotal(total_provider_types);
            }
        }
    }

    useEffect(() => {
        const loadDestinations = async () => {
            if (token && typeof token === 'string') {
                try {
                    const destinationFilterQuery = {
                        endpoint__in: destinationFilter.endpoint__in.map(a => a.id).toString(),
                        enabled: destinationFilter.enabled.map(a => a.id).toString(),
                        type__in: destinationFilter.type__in.map(a => a.id).toString(),
                        owner__in: destinationFilter.owner__in.map(a => a.id).toString(),
                        ordering: destinationFilter.ordering,
                        search: destinationFilter.search,
                        offset: destinationOffset,
                        previous: process.env.REACT_APP_BASE_URL_LOCAL + "/integrations/?pager=limit&limit=" + page_size + "&offset=" + (destinationOffset - page_size),
                        next: process.env.REACT_APP_BASE_URL_LOCAL + "/integrations/?pager=limit&limit=" + page_size + "&offset=" + (destinationOffset + page_size)
                    }
                    const temp = await getDestinationsList(token, destinationFilterQuery);

                    // check to see if destination in temp.result is in the selected array
                    let tempDestArray: Destination[] = []
                    temp.results.forEach((dest: Destination) => {
                        if (!newDestinations.map(a => a.id).includes(dest.id)) tempDestArray.push(dest)
                    })
                    setDestinations(tempDestArray);
                    setTotalDestinationCount(temp.count - newDestinations.length);
                    setReloadDestinations(false);

                } catch (err) {
                    console.log(err)
                }
            }
        }

        if (!pageLoaded) {
            loadProviderTypesData(providerTypesOffset, "");
            setPageLoaded(true);
        }
        if (reloadDestinations) loadDestinations();
        loadOrganizationsData(organizationOffset, "");
        loadDestinationTypesData(destinationTypesOffset, "");
    }, [token, reloadDestinations, providerTypes])

    const handleSelectProviderType = (pt: ProviderType) => {
        setIsProviderTypeSelected(true);
        setSelectedProviderType(pt);

        setInitialConnection((prevConnection: any) => ({
            ...prevConnection,
            type: pt.id,
        }))
    }

    const handleChangeProviderTypeSearchBar = (e: any) => {
        if (e.target.value.length >= 3 || e.target.value.length === 0) {
            loadProviderTypesData(providerTypesOffset, e.target.value);
        }
    }

    const handleProviderTypePageClick = (e: any) => {
        setProviderTypesOffset(e.selected * page_size);
        loadProviderTypesData(e.selected * page_size, "");
    }


    const handleChangeEndpoint = (e: any) => {
        setInitialConnection((prevConnection: any) => ({
            ...prevConnection,
            base_url: e.target.value
        }))
    }

    const handleChangeSchemaForm = (e: any, action_id: string) => {
        const newConfig = {
            "action": action_id,
            "data": e
        }

        if (e) {
            const index_to_find = updatedConfigurations.findIndex((a: any) => a.action === action_id)
            if (index_to_find === -1) {

                // if this is a new config id, push it to the array
                setUpdatedConfigurations((prevArray: any[]) => [...prevArray, newConfig])
            } else {

                // if it is an existing config id, replace the old config with the new one
                const tempArray = updatedConfigurations
                tempArray[index_to_find] = newConfig
                setUpdatedConfigurations(tempArray)
            }
        }
        setInitialConnection((prevConnection: any) => ({
            ...prevConnection,
            configurations: updatedConfigurations
        }))
    }

    const handleChangeName = (e: any) => {
        setInitialConnection((prevConnection: any) => ({
            ...prevConnection,
            name: e.target.value
        }))
    }

    const handleSelectOwner = (e: any) => {
        setInitialConnection((prevConnection: any) => ({
            ...prevConnection,
            owner: e.value
        }))
        setDestinationFilter(filterDestinationOwner({
            target: {
                "name": e.label,
                "value": e.value,
            }
        }, destinationFilter));
        setReloadDestinations(true);
    }

    function handleToggleProviderEnabled(e: any) {
        setInitialConnection((prevProvider: NewIntegration) => ({
            ...prevProvider,
            enabled: !initialConnection.enabled,
        }))
    }

    const handleToggleDestinationDetailsModal = async (dest_id: string) => {
        if (dest_id && token && typeof token === 'string') {
            // Append dest_id to the current URL
            navigate(`/connections/add/${dest_id}/details`, { replace: false });
        }
        setDestDetailsModal(!destDetailsModal);
        if (destDetailsModal) {
            setReloadDestinations(true);
        }
    }

    const handleToggleAddDestinationModal = async (openDest_id?: string) => {
        setAddDestModal(!addDestModal)
        if (openDest_id) {
            if (token && typeof token === 'string') {
                try {
                    const temp_destination = await getDestinationDetails(token, openDest_id)
                    handleAddDestination(temp_destination);
                } catch (err) {
                    console.log(err)
                }
            }
        }
    }

    const handleAddDestination = (dest: Destination) => {
        setTotalDestinationCount(totalDestinationCount - 1);
        // remove dest from available dests
        let availableArray: Destination[] = []
        destinations.forEach((availableDest: Destination) => {
            if (availableDest.id !== dest.id) availableArray.push(availableDest)
        });
        setDestinations(availableArray);
        // add dest to new connection
        let tempArray: Destination[] = newDestinations;
        tempArray.push(dest);
        setNewDestinations(tempArray);
        setReloadDestinations(true);
    }

    const handleRemoveDestination = (dest: Destination) => {
        setTotalDestinationCount(totalDestinationCount + 1);
        // add dest to available dests
        let availableArray: Destination[] = destinations;
        availableArray.push(dest);
        setDestinations(availableArray);
        // remove dest from new connection
        let tempArray: Destination[] = [];
        newDestinations.forEach((currentDest: Destination) => {
            if (dest.id !== currentDest.id) tempArray.push(currentDest)
        })
        setNewDestinations(tempArray);
        setReloadDestinations(true);
    }

    const handleChangeDestinationStateFilter = (e: any) => {
        let tempArray: FilterTags[] = destinationFilter.enabled
        // active was toggled
        if (e.target.value === "active") {
            if (tempArray.map(a => a.id).includes("true")) {
                let removed: FilterTags[] = []
                for (var item in tempArray) {
                    if (tempArray[item].id !== "true") {
                        removed.push(tempArray[item])
                    }
                    setDestinationFilter((prevFilter: any) => ({
                        ...prevFilter,
                        [e.target.id]: removed
                    }))
                }
            } else {
                const newItem = {
                    name: "Active",
                    id: "true",
                    attribute_name: "enabled"
                }
                tempArray.push(newItem);
                setDestinationFilter((prevFilter: any) => ({
                    ...prevFilter,
                    [e.target.id]: tempArray
                }))
            }

        } else { // inactive was toggled
            if (tempArray.map(a => a.id).includes("false")) {
                let removed: FilterTags[] = []
                for (item in tempArray) {
                    if (tempArray[item].id !== "false") {
                        removed.push(tempArray[item])
                    }
                    setDestinationFilter((prevFilter: any) => ({
                        ...prevFilter,
                        [e.target.id]: removed
                    }))
                }
            } else {
                const newItem = {
                    name: "Inactive",
                    id: "false",
                    attribute_name: "enabled"
                }
                tempArray.push(newItem);
                setDestinationFilter((prevFilter: any) => ({
                    ...prevFilter,
                    [e.target.id]: tempArray
                }))
            }
        }
        setReloadDestinations(true);
    }

    const handleChangeDestinationTypeSearchBar = (e: any) => {
        if (e.target.value.length >= 3 || e.target.value.length === 0) {
            loadDestinationTypesData(destinationTypesOffset, e.target.value);
        }
    }

    const handleLoadMoreDestinationTypes = () => {
        if (destinationTypesOffset + page_size >= destinationTypesTotal) {
            setLoadMoreDestinationTypes(false);
            return;
        }
        setDestinationTypesOffset(destinationTypesOffset + page_size);
        loadDestinationTypesData(destinationTypesOffset + page_size, "");
    }

    const handleChangeDestinationTypeFilter = (e: any) => {
        let tempArray: FilterTags[] = destinationFilter.type__in
        if (tempArray.map(a => a.id).includes(e.target.value)) {
            let removed: FilterTags[] = []
            for (var item in tempArray) {
                if (tempArray[item].id !== e.target.value) {
                    removed.push(tempArray[item])
                }

            }
            setDestinationFilter((prevFilter: any) => ({
                ...prevFilter,
                [e.target.id]: removed
            }))
        } else {
            const newTag = {
                name: e.target.name,
                id: e.target.value
            }
            tempArray.push(newTag)
            setDestinationFilter((prevFilter: any) => ({
                ...prevFilter,
                [e.target.id]: tempArray
            }))
        }
        setReloadDestinations(true);
    }

    const handleChangeDestinationUrlSearchBar = (e: any) => {
        console.log(e.target.value)
    }

    const handleChangeDestinationOwnerFilter = (e: any) => {
        let tempArray: FilterTags[] = destinationFilter.owner__in
        if (tempArray.map(a => a.id).includes(e.target.value)) {
            let removed: FilterTags[] = []
            for (var item in tempArray) {
                if (tempArray[item].id !== e.target.value) removed.push(tempArray[item])
            }
            setDestinationFilter((prevFilter: any) => ({
                ...prevFilter,
                [e.target.id]: removed
            }))
        } else {
            const newTag = {
                name: e.target.name,
                id: e.target.value
            }
            tempArray.push(newTag)
            setDestinationFilter((prevFilter: any) => ({
                ...prevFilter,
                [e.target.id]: tempArray
            }))
        }
        setReloadDestinations(true);
    }

    const handleGlobalDestinationSearch = (searchSubStr: string) => {
        setDestinationFilter((prevFilter: any) => ({
            ...prevFilter,
            search: searchSubStr
        }));
        setReloadDestinations(true);
    }

    const handleRemoveDestinationFilterTag = (e: any) => {
        if (destinationFilter.type__in.map(a => a.id).includes(e)) {
            let tempArray: FilterTags[] = destinationFilter.type__in
            let removed: FilterTags[] = []
            for (var item in tempArray) {
                if (tempArray[item].id !== e) removed.push(tempArray[item])
            }
            setDestinationFilter((prevFilter: any) => ({
                ...prevFilter,
                type__in: removed
            }))
        } else if (destinationFilter.owner__in.map(a => a.id).includes(e)) {
            let tempArray: FilterTags[] = destinationFilter.owner__in
            let removed: FilterTags[] = []
            for (item in tempArray) {
                if (tempArray[item].id !== e) removed.push(tempArray[item])
            }
            setDestinationFilter((prevFilter: any) => ({
                ...prevFilter,
                owner__in: removed
            }))
        } else if ((destinationFilter.endpoint__in.map(a => a.id).includes(e))) {
            let tempArray: FilterTags[] = destinationFilter.endpoint__in
            let removed: FilterTags[] = []
            for (item in tempArray) {
                if (tempArray[item].id !== e) removed.push(tempArray[item])
            }
            setDestinationFilter((prevFilter: any) => ({
                ...prevFilter,
                endpoint__in: removed
            }))
        } else {
            // enabled
            let tempArray: FilterTags[] = destinationFilter.enabled
            let removed: FilterTags[] = []
            for (item in tempArray) {
                if (tempArray[item].id !== e) removed.push(tempArray[item])
            }
            setDestinationFilter((prevFilter: any) => ({
                ...prevFilter,
                enabled: removed
            }))
        }
        setReloadDestinations(true);
    }

    const handleResetDestinationFilters = (e: any) => {
        setDestinationFilter({
            endpoint__in: [],
            enabled: [],
            type__in: [],
            owner__in: [],
            ordering: "",
            search: ""
        });
        setReloadDestinations(true);
    }

    const handleDestinationPageClick = (e: any) => {
        setDestinationOffset(e.selected * page_size);
        setReloadDestinations(true);
    }

    const formIsValid = () => {
        let form_errors: any = {};
        let rsjf_errors: any = {};
        if (initialConnection.name.length === 0) form_errors.name = "Name is required."
        if (initialConnection.base_url.length > 0) {
            try {
                new URL(initialConnection.base_url);
            } catch (err) {
                form_errors.base_url = "Enter a valid url including the scheme."
            }
        }
        if (initialConnection.owner === "") form_errors.owner = "Select an organization."

        setErrors(form_errors)
        updatedConfigurations.forEach((config: any, index: number) => {
            const schema_index = selectedProviderType.actions.findIndex((a: any) => a.id === config.action);
            const ajv = new Ajv({ allErrors: true, verbose: true });
            ajv.addKeyword({
                keyword: 'is_executable',
                validate: function () {
                    return true;
                },
                errors: false
            });
            addFormats(ajv);

            const schema = selectedProviderType.actions[schema_index].schema;
            const validate = ajv.compile(schema);
            const data = { ...config.data };

            if (schema.properties && typeof schema.properties === 'object') {
                Object.keys(schema.properties).forEach((key) => {
                    if (!data.hasOwnProperty(key)) {
                        data[key] = null;
                    } else {
                        if (data[key] === undefined) {
                            data[key] = null; // or any default value you prefer
                        }
                    }
                });
            } else {
                console.error('schema.properties is not defined or is not an object');
            }

            const valid = validate(data);
            if (!valid) {
                validate.errors?.forEach((error: any) => {
                    console.error(`Error in field '${error.instancePath}': ${error.message}`);
                    const field = error.instancePath.slice(1);
                    if (!rsjf_errors[selectedProviderType.actions[schema_index].id]) {
                        rsjf_errors[selectedProviderType.actions[schema_index].id] = {};
                    }
                    rsjf_errors[selectedProviderType.actions[schema_index].id][field] = `Error in field '${field}': ${error.message}`;
                });
            }
        });

        setRsjfErrors(rsjf_errors);
        return Object.keys(form_errors).length === 0 && Object.keys(rsjf_errors).length === 0;
    }

    const handleCreateConnection = async (connectionToAdd: NewIntegration) => {
        if (!formIsValid()) return;
        if (token && typeof token === 'string' && formIsValid()) {
            const temp = await createNewConnection(token, connectionToAdd);
            setCreatedConnection(temp)
            setRouteId(temp.default_route.id);
            toast.success('New connection made, ready to add destinations', {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    const handleSaveConnectionDestinations = async () => {
        if (token && typeof token === 'string') {
            const destinations = {
                "destinations": newDestinations.map(a => a.id)
            }
            await addConnectionDestinations(token, routeId, destinations);
            toast.success('Destinations configured successfully', {
                position: toast.POSITION.TOP_RIGHT
            });
            navigate("/connections/" + createdConnection?.id + "/overview");
        }
    }

    const handleClickNext = (newStep: number) => {
        if (newStep === 2) setCurrentStep(newStep)
        if (newStep === 3) {
            if (!formIsValid()) {
                setCurrentStep(currentStep)
                return
            }
            else {
                handleCreateConnection(initialConnection);
                setCurrentStep(newStep)
            }
        }
        if (newStep === 4) {
            handleSaveConnectionDestinations();
            setCurrentStep(newStep)
        }

    }

    function handleSearchOrgDropdown(e: any) {
        setOrgSearchInput(e);
        if (e.length > 1) loadOrganizationsData(orgOffset, e);
    }

    function handleLoadMoreOrgs() {
        setOrgOffset(orgOffset + page_size)
        if (organizations.length < totalOrgs) loadOrganizationsData(orgOffset + page_size, "");
    }

    const handleChangeOrganizationSearchBar = (e: any) => {
        if (e.target.value.length >= 3 || e.target.value.length === 0) {
            loadOrganizationsData(organizationOffset, e.target.value);
        }
    }

    const handleLoadMoreOrganizations = () => {
        if (organizationOffset + page_size >= organizationTotal) {
            setLoadMoreOrganizations(false);
            return;
        }
        setOrganizationOffset(organizationOffset + page_size);
        loadOrganizationsData(organizationOffset + page_size, "");
    }

    const handleCancel = () => {
        navigate("/")
    }

    return !pageLoaded ?
        (
            <Spinner />
        ) : (
            <div>
                {addDestModal &&
                    <ManageDestinationModal
                        onToggleModal={handleToggleAddDestinationModal}
                    />
                }
                <AddConnectionDetails
                    initialConnection={initialConnection}
                    errors={errors}
                    rsjfErrors={rsjfErrors}
                    providerTypes={providerTypes}
                    destinationTypes={destinationTypes}
                    organizations={organizations}
                    loadMoreOrgs={handleLoadMoreOrgs}
                    orgInputChange={handleSearchOrgDropdown}
                    destinations={destinations}
                    selectedDestinations={newDestinations}
                    filters={destinationFilter.endpoint__in
                        .concat(destinationFilter.type__in, destinationFilter.owner__in, destinationFilter.enabled)}
                    onChangeStateFilter={handleChangeDestinationStateFilter}
                    onChangeTypeFilter={handleChangeDestinationTypeFilter}
                    onChangeOwnerFilter={handleChangeDestinationOwnerFilter}
                    onChangeOwnerSearchBar={handleChangeOrganizationSearchBar}
                    loadMoreOrganizations={loadMoreOrganizations}
                    onLoadMoreOrganizations={handleLoadMoreOrganizations}
                    onGlobalDestinationFilter={handleGlobalDestinationSearch}
                    onRemoveDestinationFilterTag={handleRemoveDestinationFilterTag}
                    onResetDestinationFilters={handleResetDestinationFilters}
                    onDestinationPageClicked={handleDestinationPageClick}
                    totalDestinationCount={totalDestinationCount}
                    onAddDestination={handleToggleAddDestinationModal}
                    destinationOffset={destinationOffset}
                    onChangeEndpoint={handleChangeEndpoint}
                    onChangeDestinationUrlSearchBar={handleChangeDestinationUrlSearchBar}
                    onChangeDestinationTypeSearchBar={handleChangeDestinationTypeSearchBar}
                    loadMoreDestinationTypes={loadMoreDestinationTypes}
                    onLoadMoreDestinationTypes={handleLoadMoreDestinationTypes}
                    onChangeSchemaForm={handleChangeSchemaForm}
                    onChangeName={handleChangeName}
                    onChangeProviderEnabled={handleToggleProviderEnabled}
                    onSelectOwner={handleSelectOwner}
                    onSelectProviderType={handleSelectProviderType}
                    onSearchProviderType={handleChangeProviderTypeSearchBar}
                    onPageClickProviderTypes={handleProviderTypePageClick}
                    providerTypesOffset={providerTypesOffset}
                    providerTypesTotal={providerTypesTotal}
                    onSelectDestination={handleAddDestination}
                    onRemoveDestination={handleRemoveDestination}
                    selectedProviderType={selectedProviderType}
                    isProviderTypeSelected={isProviderTypeSelected}
                    onClickNext={handleClickNext}
                    currentStep={currentStep}
                    onCancel={handleCancel}
                    pageLoaded={pageLoaded}
                />
            </div>
        )
}